"use client";

import { useState } from "react";
import { toast } from "react-toastify";
import Button from "./Button";
import {
  ChevronDownSvg,
  ChevronUpSvg,
  RadioCheckedSvg,
  RadioUncheckSvg,
} from "@/public/svg";
import { useQuery } from "@tanstack/react-query";
import fetchAPI from "@/functions/fetchAPI";
import { paymentOrderBilling } from "@/functions/databaseData";

const settingToast = {
  position: "top-center",
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

export default function PaymentCard({
  chooseBank,
  setChooseBank,
  handleClose,
  session,
  mitra_id,
  order_id,
}) {
  const [loading, setLoading] = useState(false);
  const [showBank, setShowBank] = useState({
    0: false,
  });

  const { data: listBank } = useQuery({
    queryFn: async () => {
      const datas = await fetchAPI({
        uri: "payment/list/bank",
        method: "GET",
        token: session?.user?.token,
      });
      if (!datas?.error) return datas.data;
      return [];
    },
    queryKey: ["list_bank"],
    refetchOnWindowFocus: false,
  });

  async function handlePaymentGateway() {
    setLoading(true);

    if (!mitra_id || !order_id)
      throw new Error("mitra id / order id not found");

    try {
      const res = await paymentOrderBilling({
        token: session?.user?.token,
        mitra_id,
        order_id,
        bank_code: chooseBank?.bank_code,
        type: chooseBank?.type,
        bank_name: chooseBank?.bank_name,
      });
      if (!res?.error) {
        handleClose && handleClose();
        return (window.location.href = res?.data?.respon_url);
      }
      throw new Error(res?.error?.message);
    } catch (error) {
      toast.error(error.message, settingToast);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <div className='flex justify-between items-center'>
        <p className='subheading-semiBold text-greyscaleGON-700'>
          Pilih Opsi Pembayaran
        </p>
      </div>
      <div className='flex flex-col gap-10'>
        <div className='flex flex-col gap-4'>
          {Object.entries(listBank ?? {})
            ?.map(([_, item]) => ({ _, item }))
            ?.map((item, index) => {
              return (
                item?.item?.length > 0 && (
                  <div
                    key={index}
                    className='flex flex-col gap-4'>
                    <div
                      onClick={() =>
                        setShowBank((old) => ({
                          ...old,
                          [index]: !showBank?.[index],
                        }))
                      }
                      className='cursor-pointer py-4 px-6 border-b border-b-greyscaleGON-200 rounded-md flex flex-row items-center justify-between'>
                      <p className='subheading-medium text-greyscaleGON-700'>
                        {item?._ == "VA"
                          ? "Virtual Account"
                          : item?._ == "WA"
                          ? "Wallet Account"
                          : "Other"}
                      </p>
                      <div>
                        {!showBank?.[index] ? (
                          <ChevronDownSvg className='w-8 h-8 text-greyscaleGON-400' />
                        ) : (
                          <ChevronUpSvg className='w-8 h-8 text-greyscaleGON-400' />
                        )}
                      </div>
                    </div>
                    {!showBank?.[index] ? null : (
                      <div className='flex flex-col gap-1'>
                        {item?.item?.map((subItem, subIndex) => {
                          const myChoose =
                            chooseBank?.bank_code === subItem?.bank_code;
                          return (
                            <div
                              key={subIndex}
                              onClick={() =>
                                setChooseBank((old) =>
                                  myChoose
                                    ? {
                                        order_id: old?.order_id,
                                      }
                                    : {
                                        ...subItem,
                                        order_id: old?.order_id,
                                      }
                                )
                              }
                              className={
                                "cursor-pointer mx-6 py-2 gap-4 flex flex-row items-center rounded-md border-b border-b-greyscaleGON-200"
                              }>
                              <div>
                                {myChoose ? (
                                  <RadioCheckedSvg className='w-4 h-4 text-primaryGON-400' />
                                ) : (
                                  <RadioUncheckSvg className='w-4 h-4 text-primaryGON-400' />
                                )}
                              </div>
                              <p className='subheading-regular text-greyscaleGON-700'>
                                {subItem?.name}
                              </p>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                )
              );
            })}
        </div>
        <div className='flex flex-col-reverse xs:flex-row w-full justify-between gap-4 items-center '>
          <Button
            label='Bayar Nanti!'
            variants='outline'
            disable={loading}
            onClick={() => {
              handleClose && handleClose();
            }}
            className='w-full'
          />
          <Button
            label='Bayar Sekarang'
            disable={loading || !chooseBank?.bank_code}
            onClick={() => handlePaymentGateway(chooseBank)}
            className='w-full'
            loading={loading}
          />
        </div>
      </div>
    </>
  );
}
